import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { useSelector } from 'react-redux'
import { FlexContainer, Paragraph, parseBools } from 'heliocor-ui'
import { SectionWrapper } from './SectionWrapper'

const valueParser = ({ field, detailHasData, data, fieldsInfo, formatting }) => {
    const parseCurrency = value => `${parseInt(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} ${formatting.currency}`   
    const coreFieldsWithAmount = ['netWealth', 'netIncome']
    const type = fieldsInfo[field] && fieldsInfo[field].type
    const isCurrency = fieldsInfo[field] && fieldsInfo[field].currency  
    switch (type) {
        case 'INPUT_TEXT':
        case 'TEXT':
        default:
            return detailHasData
        case 'DATE':
            const dateArray = detailHasData.split('-')
            return formatting.dateFormat === 'DD/MM/YYYY' ?
                [dateArray[2], dateArray[1], dateArray[0]].join('/') :
                [dateArray[1], dateArray[2], dateArray[0]].join('/')
        case 'NUMBER':
            return isCurrency || coreFieldsWithAmount.includes(field) ? parseCurrency(detailHasData) : detailHasData
        case 'RADIOBUTTON':
        case 'SELECT':
        case 'MULTI_SELECT':
            const isCustom = !!fieldsInfo[field].customOptions  
            const getCustomMultiLabels = () => {
                return data[field]
                    .map(el => {
                        const option = fieldsInfo[field].customOptions.find(option => option.value === el)
                        return option?.label || option?.name
                    })
                    .join(', ')
            }   
            return Array.isArray(detailHasData)
                ? isCustom
                    ? getCustomMultiLabels(data, field, fieldsInfo[field].customOptions)
                    : detailHasData.join(', ')
                : (detailHasData.label || detailHasData.name) || detailHasData
        
        case 'CHECK':
        case 'BOOLEAN':
            return parseBools(detailHasData)
        case 'CREDIT_CARD':
            return detailHasData.toString().replace(/\d{4}?(?=...)/g, '$& ')
    }
}

export const SummaryList = ({fields, data, title, labels, fieldsInfo, handleChangeStep, canEdit}) => {
    const fieldsToRemove = ['sameAddress', 'companyLookup']
    const formatting = useSelector(state => state.settings.formattingOptions)
    const customFields = useSelector(state => state.settings.customFields)
    
    const showCategory = !isEmpty(data) && fields?.some(field => (!isEmpty(data?.[field]) || data[field] === false))

    return showCategory && (
        <SectionWrapper
            id={`summary-${title}`}
            title={title}
            canEdit={canEdit}
            handleChangeStep={handleChangeStep}
        >
            {fields
                .filter(field => !fieldsToRemove.includes(field))
                .map((field, index) => {

                    let detailHasData = ((!isEmpty(data[field]) || !isNaN(data[field])) && data[field]) || undefined

                    const customOptions = customFields[title]
                            ?.find(prop => prop.id === field)?.customOptions

                    if (customOptions && detailHasData && typeof detailHasData !== 'object') {
                        const label = customOptions.find(option => option.value === (detailHasData))?.label
                        detailHasData = label && {label}
                    }

                    return (detailHasData || detailHasData === false) &&
                        <FlexContainer key={index} data-cy={`summary-field-${field}`}>
                            <FlexContainer width="60%">
                                <Paragraph margin="5px 0px" width="60%">
                                    {labels[field]}:
                                </Paragraph>
                            </FlexContainer>
                            <FlexContainer width="40%">
                                <Paragraph margin="5px 0px 5px 5px" width="40%">
                                    {valueParser({ field, detailHasData, data, fieldsInfo, formatting })}
                                </Paragraph>
                            </FlexContainer>
                        </FlexContainer>
                    }
                )
            }
        </SectionWrapper>
    )
}